import { render, staticRenderFns } from "./PersonPwd.vue?vue&type=template&id=3ed5130c&scoped=true"
import script from "./PersonPwd.vue?vue&type=script&lang=js"
export * from "./PersonPwd.vue?vue&type=script&lang=js"
import style0 from "./PersonPwd.vue?vue&type=style&index=0&id=3ed5130c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed5130c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed5130c')) {
      api.createRecord('3ed5130c', component.options)
    } else {
      api.reload('3ed5130c', component.options)
    }
    module.hot.accept("./PersonPwd.vue?vue&type=template&id=3ed5130c&scoped=true", function () {
      api.rerender('3ed5130c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/user/PersonPwd.vue"
export default component.exports